import {
  useCallback,
  useState,
} from 'react';

import useConnectWallet from '@/store/wallet/useConnectWallet';

const useAddLiquidityStaticCall = (tokenA: string,
    tokenB: string,
    amountADesired: BigInt,
    amountBDesired: BigInt,
    amountAMin: BigInt,
    amountBMin: BigInt,
    deadline: BigInt,
) => {
    const { address, contractEvm: { router } } = useConnectWallet()
    const [addLiquidityStaticCallLod, setAddLiquidityStaticCallLod] = useState(false)
    const [liquidityStaticCall, setLiquidityStaticCall] = useState(BigInt(0))
    const addLiquidityStaticCall = useCallback(async () => {
        if (router && tokenB && tokenA && amountADesired && amountBDesired && deadline) {
            try {
                setAddLiquidityStaticCallLod(true); // 开始加载状态
                const res = await router.addLiquidity.staticCall(
                    tokenA,
                    tokenB,
                    amountADesired,
                    amountBDesired,
                    amountAMin,
                    amountBMin,
                    address,
                    deadline
                );
                setLiquidityStaticCall(res[2])
            } catch (error) {
                console.log('useAddLiquidityStaticCall error:', error);
            } finally {
                setAddLiquidityStaticCallLod(false)
            }
        }
    }, [router, tokenB, tokenA, amountADesired, amountBDesired, amountAMin, amountBMin, deadline, address]);
    return {
        addLiquidityStaticCallLod,
        liquidityStaticCall,
        addLiquidityStaticCall
    }
}

export default useAddLiquidityStaticCall